'use client';
var IDENT = "InlineInput";
var defaultProps = {
    align: "center"
};

export { IDENT, defaultProps };
